<template>
    <stick-pop v-bind="$attrs" @click="show">
        <i class="el-icon-time" style="font-weight: 600"></i>
    </stick-pop>
</template>

<script>
    import StickPop from "./StickPop";
    import {getMyHeader, isHybridAgent} from "../../../utils";

    export default {
        name: "ViewHis",
        components: {StickPop},
        methods: {
            show(){
                // if(isHybridAgent()) plus.device.vibrate();
                getMyHeader().$refs.userViewHis.show();
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/stickpops/ViewHis.vue